<template>
	<div class="content">
		<div class="content__row">
			<div class="content__column content__column--wide">
				<h1 class="content__title">Envíos Gratis</h1>
			</div>
		</div>
		<div class="content__row">
			<option-list :filters="filters"></option-list>
			<option-view :option="option" v-if="optionAction === 'view' && option"></option-view>
			<option-edit @new="newOption" :option="option" v-if="optionAction === 'edit'" :key="key"></option-edit>
			<div class="content__column content__column--small">
				<h1 class="content__title">Opciones</h1>
				<div class="information">
					<h2 class="content__subtitle">Filtro</h2>

					<div class="form__container">
						<label for="search" class="form__label">búsqueda Libre</label>
						<input type="text" name="search" id="search" class="form__input" v-model="search" @keyup="setFilters" />
					</div>

					<div class="form__container">
						<label class="form__label form__label--required" for="status_id">Mostrar opciones por estatus</label>
						<div class="form__select-container">
							<select id="status_id" class="form__select" name="status_id" v-model="status_id">
								<option :value="null">Todos</option>
								<option value="1">Activos</option>
								<option value="2">Inactivos</option>
							</select>
						</div>
					</div>

				</div>
			</div>
		</div>
		<button @click.prevent="newOption" class="btn btn__add">Agregar</button>
	</div>
</template>

<script>
	import httpService from '@/core/api/request'
	import optionList from './list'
	import optionView from './view'
	import optionEdit from './edit'
	export default {
	mixins: [httpService],
		components: {
			optionList,
			optionView,
			optionEdit
		},
		data: function() {
			return {
				key: 0,
				search: null,
				status_id: null,
				filters: undefined,
				optionAction: null,
				option: null
			}
		},
		mounted: function() {
			this.$on('view', id => {
				this.getOption(id, 'view')
			})
			this.$on('edit', id => {
				this.getOption(id, 'edit')
			})
		},
		methods: {
			setFilters: function() {
				let filter = ''
				if (this.search && this.search.length > 1) {
					filter = filter + '&search=' + this.search
				}
				if (this.status_id) {
					filter = filter + '&status_id=eq:' + this.status_id
				}
				filter = filter.replace(/(^&+|&+$)/, '')
				if (filter.length > 0) {
					this.filters = filter
				} else {
					this.filters = undefined
				}
			},
			getOption: function(id, action) {
				this.optionAction = action
				let httpRequest = {
					params: '',
					module: 'free_shipping'
				}
				this.getById(id, httpRequest).then(option => {
					this.option = option.data
				})
			},
			newOption: function() {
				this.option = undefined
				this.key = ++this.key
				this.optionAction = 'edit'
			}
		}
	}
</script>

<style lang="sass">
	@import "../../assets/sass/components/_home"
	@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/free_shipping/free.shipping.vue